var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'mobile-device': _vm.isMobileDevice, 'desktop-device': !_vm.isMobileDevice, 'wechat-browser': _vm.isWechatBrowser },attrs:{"id":"app"}},[_c('device-detector'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }